import React, { ChangeEvent, FC } from "react";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import Icon from "../../../../components/Icon/Icon";
import Input from "../../../../components/Input/Input";
import {
  InputWrapper,
  SearchButton,
} from "../../../../components/SearchInput/SearchInput.styles";

interface BooksSearchPassportsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const BooksSearchPassports: FC<BooksSearchPassportsProps> = ({
  searchQuery,
  setSearchQuery,
}) => {
  const { t } = useTranslation("common");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleButtonClick = () => {
    if (searchQuery) {
      setSearchQuery("");
    }
  };

  const iconType = searchQuery ? IconType.Close : IconType.Search;

  return (
    <InputWrapper>
      <Input
        value={searchQuery}
        name="search"
        onChange={handleChange}
        placeholder={t("books.passports.searchPassports")}
      />
      <SearchButton
        title={t("common.search")}
        aria-label="search"
        onClick={handleButtonClick}
      >
        <Icon type={iconType} />
      </SearchButton>
    </InputWrapper>
  );
};

export default React.memo(BooksSearchPassports);
